import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <div className="components one-second-animation">
      <p className="p">
        I'm currently looking for opportunities in Delhi-NCR (India), so please
        reach out if you are looking for an enthusiastic and creative developer!{" "}
      </p>
      <br></br>
      <div id="contact-div">
        <a
          href="https://github.com/Ishaan-11"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            src={require("../../media/github-icon.svg").default}
            alt="github-icon"
            className="contact-icons"
          />
        </a>
        <br></br>
        <a
          href="https://www.linkedin.com/in/ishaan11"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            src={require("../../media/linkedin-icon.svg").default}
            alt="linkedin-icon"
            className="contact-icons"
          />
        </a>
        <br></br>
        <a href={`mailto:ishaansharma1998@gmail.com`}>
          <img
            src={require("../../media/send.png").default}
            alt="send.png"
            className="contact-icons"
          />
        </a>
        <br></br>
      </div>
    </div>
  );
}

export default Contact;
